import useProviderRecordEditable from "../../../../../../../../../../hooks/useProviderRecordEditable";
import FieldInfo from "../../../components/FieldInfo";
import getUpdatedString from "../../../components/utils/getUpdatedString";
import { useProCliStore } from "../../../hooks/useProCliStore";
import getHistoryEntryWithFallback from "../utils/getHistoryEntryWithFallback";

import DocumentStatus from "./components/DocumentStatus";
import TransportationStatus from "./components/TransportationStatus";
import TreatmentStatus from "./components/TreatmentStatus";

export default function Status({
  currentAccordionItem,
  activateButtons,
  deactivateButtons,
  providerHistory,
}) {
  const { setProvidersData } = useProCliStore();
  const index = currentAccordionItem.index;
  const proCliData = currentAccordionItem.proCliData;
  const canEditRecord = useProviderRecordEditable(proCliData);
  const providerTransportationValue = proCliData?.providerTransportation;
  const treatmentHistory = getHistoryEntryWithFallback(
    providerHistory?.finishedTreatment,
    proCliData
  );
  const documentHistory = getHistoryEntryWithFallback(
    providerHistory?.medicalDocumentsStatus,
    proCliData
  );

  const updateProviderInfo = (updatedData = null) => {
    if (!updatedData) {
      deactivateButtons();
      return;
    }
    if (updatedData.get(index).editableFields === null) {
      deactivateButtons();
    } else {
      activateButtons();
    }
    if (updatedData !== null) {
      setProvidersData(updatedData);
    }
  };

  return (
    <div id="Provider-Statuses" data-testid="Provider-Statuses">
      <div className="mt-4 flex w-full flex-row flex-wrap justify-start">
        <div className="m-0 flex w-1/2 flex-row justify-start p-0">
          <div>
            <TreatmentStatus
              canEdit={canEditRecord}
              title={"Treatment"}
              index={index}
              fieldName={"treatmentStatus"}
              initialValue={proCliData?.finishedTreatment}
              updateProviderInfo={updateProviderInfo}
            />
            {treatmentHistory && (
              <FieldInfo
                title={"Updated"}
                value={getUpdatedString(treatmentHistory.user, treatmentHistory.timestamp)}
              />
            )}
          </div>
        </div>

        <div className="m-0 flex w-1/2 flex-row justify-start p-0">
          <div>
            <DocumentStatus
              canEdit={canEditRecord}
              title={"Document"}
              fieldName={"documentStatus"}
              index={index}
              initialValue={proCliData?.medicalDocumentsStatus}
              updateProviderInfo={updateProviderInfo}
            />
            {documentHistory && (
              <FieldInfo
                title={"Updated"}
                value={getUpdatedString(documentHistory.user, documentHistory.timestamp)}
              />
            )}
          </div>
        </div>

        <div className="m-0 mt-4 flex w-1/2 flex-row justify-start p-0">
          <div>
            <TransportationStatus
              canEdit={canEditRecord}
              title={"Provider Transportation"}
              index={index}
              fieldName={"providerTransportationStatus"}
              initialValue={providerTransportationValue}
              updateProviderInfo={updateProviderInfo}
            />
          </div>
        </div>

        <div className="m-0 mt-4 flex w-1/2 flex-row justify-start p-0">
          <div>
            <TransportationStatus
              canEdit={canEditRecord}
              title={"HNS Transportation"}
              index={index}
              fieldName={"hnsTransportationStatus"}
              initialValue={proCliData?.hnsTransportation}
              updateProviderInfo={updateProviderInfo}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
